import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import CustomSpin from '../../../../elements/CustomSpin'
import DeliveryDetails from '../../../../elements/DeliveryDetails'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import withMapList from '../../../../elements/HOC/withMapList'
import MultiCurrency from '../../../../elements/MultiCurrency'
import RegisteredPartnerDetails from '../../../../elements/RegisteredPartnerDetails'
import Taxes from '../../../../elements/Taxes'
import React, { useEffect } from 'react'
import { Checkbox, Col, DatePicker, Form, Icon, Input, InputNumber, Row } from 'antd'
import { compose } from 'recompose'
import { capitalize, get, isEmpty } from 'lodash'
import withLoadingSection from '../../../../elements/HOC/withLoadingSection'
import { dateVal, findCascadersParents, strVal } from '../../../../modules/Utils'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import moment from 'moment'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withSort from '../../../../elements/HOC/withSort'
import {
  boolLabelItemLayout,
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
} from '../../../../modules/FormItems'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import SalesContractsApi from '../../../../api/Sales/SalesContracts'
import CentersCascader from '../../../../elements/Cascader/CentersCascader'
import withData from '../../../../elements/Select/withData'
import withKeyValue from '../../../../elements/HOC/WithKeyValue'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import { AddQuoteContext } from '../../../../components/Sales/Quotes/AddQuote/AddQuoteCont'
import { Link } from 'react-router-dom'
import IconText from '../../../../elements/IconText'

const salesContractsApi = new SalesContractsApi()
const { TextArea } = Input

function QuoteForm(props) {
  const { enquiry, onChangeEnquiry } = React.useContext(AddQuoteContext)
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  const { data: centers, fetching: fetchingCenters, fetchURL: fetchCenters } = useFetchURL(
    `foxxapi/centers?select=_id,name,_parent`
  )

  const { quote, isUpdatable, type, lines, fetchingEnquiry } = React.useContext(AddQuoteContext)

  const contractID = getFieldValue('contract._id') || get(quote, 'contract._id', '')
  const contractKey = contractID.replace('salesContracts/', '')
  const isExistingContract = getFieldValue('isExistingContract') || get(quote, 'isExistingContract', false)
  const { object: contract } = useFetchObject(
    () => salesContractsApi.get(contractKey),
    false,
    [contractKey],
    isEmpty(contractKey)
  )

  useEffect(() => {
    if (!isEmpty(contract))
      setFieldsValue({
        centers: get(contract, 'budget.cost._id'),
        'company._id': get(contract, 'company._id'),
      })
  }, [contract._rev])

  const isProforma = getFieldValue('type') === 'Pro-Forma Invoice'

  let enquiryID = getFieldValue('enquiry._id') || get(enquiry, 'enquiry._id')
  const enqKey = enquiryID && enquiryID.replace('activities/', '')

  const [showDesc, setShowDesc] = React.useState(() => !isEmpty(quote.description))

  //console.log(findCascadersParents(centers, strVal(quote, 'center._id')), get(quote, 'centers'))
  return (
    <Form layout={'horizontal'}>
      <FormSectionTitle title={'QUOTATION DETAILS'} />
      <Row>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label={'Date'}>
            {getFieldDecorator('date', {
              initialValue: dateVal(quote, 'date') || moment(),
              rules: rules.select,
            })(
              <DatePicker
                style={{ width: '80%' }}
                onChange={(e) =>
                  setFieldsValue({
                    'validity.date': moment(e).add(1, 'M').subtract(1, 'd'),
                  })
                }
                placeholder={'Date'}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label={'Valid till'}>
            {getFieldDecorator('validity.date', {
              initialValue: dateVal(quote, 'validity.date') || moment().add(1, 'M').subtract(1, 'd'),
              rules: [{ required: true, message: 'Please Select a date!' }],
            })(
              <DatePicker
                style={{
                  width: getFieldValue('validity.date') ? '80%' : '100%',
                }}
                disabledDate={disabledDate}
                placeholder={'Valid till'}
              />
            )}
            {getFieldValue('validity.date') && (
              <span style={{ marginLeft: 15, color: 'darkred' }}>
                {getFieldValue('validity.date').diff(getFieldValue('date') ? getFieldValue('date') : moment(), 'd') + 1}{' '}
                Days
              </span>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label={'Client Ref.'}>
            {getFieldDecorator('reference.no', {
              initialValue: get(quote, 'reference.no'),
            })(<Input style={{ width: '80%' }} placeholder={'Reference No.'} />)}
          </Form.Item>
        </Col>
      </Row>

      <CustomSpin spinning={fetchingEnquiry}>
        <Row>
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label={'Enquiry'}>
              {getFieldDecorator('enquiry._id', {
                initialValue: type === 'new' ? enquiry._id : get(quote, 'enquiry._id'),
                // rules: rules.select,
              })(
                <EnquiriesSelect
                  style={{ width: '80%' }}
                  onChange={onChangeEnquiry}
                  keyAtr={'_id'}
                  valueAtr={'display'}
                  placeholder={'Select an enquiry'}
                />
              )}
              <Link target={'_blank'} to={`/clients/enquiries/${enqKey}/update`}>
                <Icon style={{ marginLeft: 5 }} type="fullscreen" />
              </Link>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              readOnly={lines.length > 0}
              display={capitalize(strVal(quote, 'quoteType'))}
              {...defaultFormItemLayout}
              label={'Quote For'}>
              {getFieldDecorator('quoteType', {
                initialValue: get(quote, 'quoteType') || 'MRO',
                rules: rules.select,
              })(<ProductTypeSelect style={{ width: '80%' }} />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label={'Type'}>
              {getFieldDecorator('type', {
                initialValue: get(quote, 'type') || 'Quotation',
                rules: [
                  {
                    required: true,
                    message: 'Please Select a Type!',
                  },
                ],
              })(<TypeSelect style={{ width: '80%' }} placeholder={'Type'} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={18}>
            <Form.Item {...fullWidthFormItemLayout} label={'Title '}>
              {getFieldDecorator('title', {
                initialValue: get(quote, 'title'),
                rules: [{ required: true, message: 'Please Input a Title!' }],
              })(<Input placeholder={'Title'} />)}
              <IconText
                text={showDesc !== true ? 'Optionally Add Quotation Summary' : 'Remove Quotation Summary'}
                type={showDesc !== true ? 'plus-circle' : 'minus-circle'}
                onClick={() => {
                  setShowDesc(!showDesc)
                  quote.description = ''
                  setFieldsValue({ description: '' })
                }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item {...boolLabelItemLayout} label={'IS ESTIMATE'}>
              {getFieldDecorator('isEstimate', {
                initialValue: get(quote, 'isEstimate'),
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {showDesc === true && (
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label={'Quotation Summary'}>
                {getFieldDecorator('description', {
                  initialValue: get(quote, 'description'),
                  rules: rules.input,
                })(<TextArea placeholder={'Summary'} />)}
              </Form.Item>
            </Col>
          )}
        </Row>

        <Row>
          <Taxes
            doc={quote}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'quote',
              hideRate: true,
            }}
          />
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label={'Non-Priced PDF'}>
              {getFieldDecorator('nonPricing', {
                initialValue: get(quote, 'nonPricing'),
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label={'Additional Charges'}>
              {getFieldDecorator('isAdditionalCharges', {
                initialValue: get(quote, 'isAdditionalCharges'),
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>
          </Col>
        </Row>
        <FormSectionTitle title={'CLIENT ACCOUNT'} />
        <Row>
          <RegisteredPartnerDetails
            isUpdatable={isUpdatable}
            doc={quote}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              type: 'quote',
              showRepEmail: true,
            }}
          />
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Profit Center">
              {getFieldDecorator('centers', {
                initialValue: strVal(quote, 'center._id')
                  ? findCascadersParents(centers, strVal(quote, 'center._id'))
                  : get(quote, 'centers'),
                rules: rules.select,
              })(
                <CentersCascader
                  key={getFieldValue('company._id') || get(contract, 'company._id')}
                  category={'Profit'}
                  company={getFieldValue('company._id') || get(contract, 'company._id')}
                  placeholder="Select a Division"
                  keyAtr={'key'}
                  valueAtr={'value'}
                  disabled={isExistingContract === true}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <MultiCurrency
            doc={quote}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              type: 'vendorQuote',
            }}
          />
        </Row>
      </CustomSpin>
      <Row>
        <FormSectionTitle title={'PAYMENT TERMS'} />
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Method'}>
              {getFieldDecorator('paymentTerms.method', {
                initialValue: get(quote, 'paymentTerms.method') || 'Account',
                rules: [
                  {
                    required: true,
                    message: `Can't be empty.`,
                  },
                ],
              })(<PaymentTermsMethodSelect placeholder={'Method'} />)}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label={'Additional Terms'}>
              {getFieldDecorator('paymentTerms.terms', {
                initialValue: get(quote, 'paymentTerms.terms'),
              })(<TextArea placeholder={'Additional Terms'} />)}
            </Form.Item>
          </Col>
        </Row>
      </Row>
      <DeliveryDetails
        doc={quote}
        {...{
          getFieldDecorator,
          getFieldValue,
          setFieldsValue,
          resetFields,
          type: 'Quote',
        }}
      />
      {getFieldValue('isAdditionalCharges') && (
        <Row>
          <h2>Additional Charges</h2>
          <h4>PRODUCT INSPECTION / CERTIFICATION</h4>
          <h4>Certification</h4>
          <Row>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Included'}>
                {getFieldDecorator('cert.included', {
                  initialValue: get(quote, 'cert.included'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
            {!getFieldValue('cert.included') && (
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Amount'}>
                  {getFieldDecorator('cert.price', {
                    initialValue: get(quote, 'cert.price'),
                  })(<InputNumber placeholder={'Amount'} />)}
                </Form.Item>
              </Col>
            )}
          </Row>
          <h4>Inspection</h4>
          <Row>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Included'}>
                {getFieldDecorator('insp.included', {
                  initialValue: get(quote, 'insp.included'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
            {!getFieldValue('insp.included') && (
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Amount'}>
                  {getFieldDecorator('insp.price', {
                    initialValue: get(quote, 'insp.price'),
                  })(<InputNumber placeholder={'Amount'} />)}
                </Form.Item>
              </Col>
            )}
          </Row>
          <h4>PRODUCT INSPECTION / CERTIFICATION</h4>
          <h4>Freight</h4>
          <Row>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Included'}>
                {getFieldDecorator('freight.included', {
                  initialValue: get(quote, 'freight.included'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
            {!getFieldValue('freight.included') && (
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Amount'}>
                  {getFieldDecorator('freight.price', {
                    initialValue: get(quote, 'freight.price'),
                  })(<InputNumber placeholder={'Amount'} />)}
                </Form.Item>
              </Col>
            )}
          </Row>
          <h4>Consular / Legalisation </h4>
          <Row>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Included'}>
                {getFieldDecorator('consular.included', {
                  initialValue: get(quote, 'consular.included'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
            {!getFieldValue('consular.included') && (
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Amount'}>
                  {getFieldDecorator('consular.price', {
                    initialValue: get(quote, 'consular.price'),
                  })(<InputNumber placeholder={'Amount'} />)}
                </Form.Item>
              </Col>
            )}
          </Row>
          <h4>Insurance </h4>
          <Row>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Included'}>
                {getFieldDecorator('insurance.included', {
                  initialValue: get(quote, 'insurance.included'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
            {!getFieldValue('insurance.included') && (
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Amount'}>
                  {getFieldDecorator('insurance.price', {
                    initialValue: get(quote, 'insurance.price'),
                  })(<InputNumber placeholder={'Amount'} />)}
                </Form.Item>
              </Col>
            )}
          </Row>
          <h4>Special Packing</h4>
          <Row>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Included'}>
                {getFieldDecorator('packing.included', {
                  initialValue: get(quote, 'packing.included'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
            {!getFieldValue('packing.included') && (
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Amount'}>
                  {getFieldDecorator('packing.price', {
                    initialValue: get(quote, 'packing.price'),
                  })(<InputNumber placeholder={'Amount'} />)}
                </Form.Item>
              </Col>
            )}
          </Row>
        </Row>
      )}
    </Form>
  )
}

export const PaymentTermsMethodSelect = compose(
  withData({
    data: ['account', 'draft', 'other', 'loc', 'Payment In Advance'],
  }),
  withKeyValue({ capitalize: true }),
  withSort
)(CustomSelect)

const TypeSelect = compose(
  withSelectFetch({
    dropdown: 'quotes',
    name: 'type',
  }),
  withSpinning,
  withSort
)(CustomSelect)
export const DueTypeSelect = compose(
  withSelectFetch({
    dropdown: 'quotes',
    name: 'dueType',
  }),
  withSpinning,
  withSort
)(CustomSelect)

export const ProductTypeSelect = compose(
  withSelectFetch({ dropdown: 'products', name: 'type' }),
  withKeyValue(),
  withSort
)(CustomSelect)

export const ClientTypeSelect = compose(
  withSelectFetch({ dropdown: 'products', name: 'type' }),
  withKeyValue(),
  withSort
)(CustomSelect)

const EnquiriesSelect = compose(
  withUrlFetch({
    name: 'activities',
    url: `enquiries/?select=code,_id,_key,title,active=true`,
    cache: false,
    forceFetch: true,
  }),
  withSpinning,
  //withSort,
  withMapList((enquiry) => ({
    ...enquiry,
    display: `${enquiry.code} - ${enquiry.title}`,
  }))
)(CustomSelect)

function disabledDate(current) {
  // Can not select days before today and today
  return current && current < moment().endOf('day')
}

QuoteForm.propTypes = {}
QuoteForm.defaultProps = { type: 'new' }

export default compose(Form.create(), withLoadingSection)(QuoteForm)
